import { LOCALE_ID, Injectable, inject } from "@angular/core";

import { ILgFormatterOptions, ILgFormatter } from "../implementation/formatter-types";
import { NumberFormatter } from "../implementation/number-formatter";
import { ILgFormatterFactory } from "./formatter-factory-types";
import { LG_FORMATTER_OPTIONS } from "./lg-formatter-options";

@Injectable({ providedIn: "root" })
export class IntegerFormatterFactory implements ILgFormatterFactory {
    private _locale = inject(LOCALE_ID);
    private _localFormatterOptions = inject(LG_FORMATTER_OPTIONS, { optional: true });
    names = ["int"];

    create(defaultOptions: ILgFormatterOptions = {}): ILgFormatter<number> {
        return new NumberFormatter(
            { ...defaultOptions, ...this._localFormatterOptions, decimals: 0 },
            this._locale
        );
    }
}
